import { createColumnHelper } from '@tanstack/react-table';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { ColumnFilterType, Link } from '@optimus-web/core';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { RowActions } from '../../components/RowActions/RowActions';

const columnHelper = createColumnHelper<PortfolioEnterpriseGroupResult>();

export const getColumns = ({
    onDelete,
    onNameClick,
}: {
    onDelete: (propertyGroupId: string) => void;
    onNameClick: (propertyGroup: PortfolioEnterpriseGroupResult) => void;
}) => [
    columnHelper.accessor('name', {
        header: () => <LocalizedText textKey={TextKey.Name} />,
        enableSorting: true,
        enableColumnFilter: true,
        meta: {
            filtersType: ColumnFilterType.String,
        },
        cell: (props) => (
            <Link standalone variant="basic" onClick={() => onNameClick(props.row.original)}>
                {props.row.original.name}
            </Link>
        ),
    }),
    columnHelper.accessor('propertyIds', {
        header: () => <LocalizedText textKey={TextKey.Properties} />,
        cell: (props) => props.getValue().length,
        enableSorting: true,
        sortingFn: (rowA, rowB) => rowA.original.propertyIds.length - rowB.original.propertyIds.length,
    }),
    columnHelper.display({
        id: 'actions',
        header: '',
        meta: { align: 'end' },
        cell: (props) => (
            <RowActions
                propertyGroup={props.row.original}
                enterpriseIds={props.row.original.propertyIds}
                onDelete={onDelete}
                deleteTextKey={TextKey.PropertyGroupDelete}
            />
        ),
    }),
];
